import type { User } from 'types/users';
import isEmpty from 'lodash.isempty';
import type { Moment } from 'moment';
import moment from 'moment';
import { OrderStatus } from 'types/orders';
import { generateRangeMomentArray } from './generateRangeMomentArray';

export const isUserAlreadyBooked = (
  user: User | null,
  startDate?: Moment,
  endDate?: Moment,
): boolean => {
  if (!user || !Array.isArray(user.orders) || isEmpty(user?.orders)) {
    return false;
  }
  if (!startDate || !endDate) {
    return false;
  }
  const userOrders = user.orders.filter(
    (item) =>
      ![
        OrderStatus.REFUSED,
        OrderStatus.DONE,
        OrderStatus.ARCHIVED,
        OrderStatus.OUTDATED,
      ].includes(item.status),
  );

  const possibleOrderDates = generateRangeMomentArray(startDate, endDate);

  return userOrders.some((order) => {
    return (
      possibleOrderDates.includes(
        moment(order.rentStartDate).format('DD/MM/YYYY'),
      ) ||
      possibleOrderDates.includes(moment(order.endDate).format('DD/MM/YYYY'))
    );
  });
};
